import { FC } from 'react';
import cx from 'classnames/bind';

import { Layout } from '@/components/Layout';
import { Button } from '@/components/Button';
import PreviewTraining from '@/assets/previewTraining.png';

import styles from './Step1.module.scss';

interface Step1Props {
  setStep: (value: number) => void;
  totalPoints: number;
}

const cn = cx.bind(styles);

const Step1: FC<Step1Props> = ({ setStep, totalPoints }) => {
  const startTraining = () => {
    setStep(8);
  };

  return (
    <Layout className={cn('container')}>
      {totalPoints > 0 && (
        <div className={cn('wrapper')}>
          <img
            src={PreviewTraining}
            className={cn('img')}
            alt="Диалог между клиентом и сотрудником"
          />
          <div className={cn('content')}>
            <h1 className={cn('title')}>
              Информируй
              <br />
              правильно
            </h1>
            <p className={cn('description')}>
              Проверьте ваши знания! Примите участие в активности и проверьте,
              насколько эффективно вы работаете с клиентами. За первое
              выполнение данной активности, вы сможете получить до {totalPoints}
              &nbsp;эксперт-баллов. Баллы будут начислены только после полного
              прохождения всех сценариев.
            </p>
            <Button handleClick={startTraining}>Начать</Button>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Step1;
